<template>
  <div>
    <div class="accountmanager">
      <div class="accountmanager_item" v-for="(item,ele,index) in targetData" :key="index">
        <p class="accountmanager_item_title">{{ele}}</p>
        <p class="accountmanager_item_desc">{{item}}</p>
      </div>
    </div>
  </div>
</template>
    <script>
export default {
  name: "AccountManager",
  data() {
    return {
        targetData:{
            '可用余额':'balance',
            "冻结资金":'blocked_balance',
            "备注信息":'note'
        }
    };
  },
  mounted() {
      this.getAccountFun()
  },
  methods: {
    getAccountFun() {
      this.$api.get("/api/cashaccount/cashaccountList", {}, (res) => {
        this.targetData['可用余额'] = res.data.balance;
        this.targetData['冻结资金'] = res.data.blocked_balance;
        this.targetData['备注信息']= res.data.note;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.accountmanager {
  background: #fff;
  min-height: 600px;
  padding: 20px;
}
.accountmanager_item {
  height: 50px;
  margin-top: 20px;
  p {
    display: inline-block;
    font-size: 16px;
  }
  .accountmanager_item_title {
    min-width: 90px;
    font-weight: bold;
    font-size: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// AccountManager.vue?75343ac4